import {useEffect, useState} from 'react'
import LibraryResponse from './near/LibraryNearResponse'
import {BooksitoutServer} from '../../config/BooksitoutServer'
import Paging from '../../common/hooks/Paging'

const useLibraryByBookCount = (lat: number | null, long: number | null, region: string, size: number) => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)

    const [libraries, setLibraries] = useState<LibraryResponse[]>([])

    const [page, setPage] = useState<number>(1)
    const [isLast, setIsLast] = useState<boolean>(false)
    const [totalPages, setTotalPages] = useState<number>(0)

    const [previousRegion, setPreviousRegion] = useState<string | null>(null)
    const [isPreviousLatLongNotNull, setIsPreviousLatLongNotNull] = useState<boolean>(false)

    useEffect(() => {
        setIsLoading(true)
        setIsError(false)

        const isRegionDifferentFromPrevious = region !== previousRegion
        const isCurrentLatLongNotNull = lat !== null && long !== null
        const isPreviousLatLongNullAndCurrentLatLongNotNull = !isPreviousLatLongNotNull && isCurrentLatLongNotNull

        if (isRegionDifferentFromPrevious || isPreviousLatLongNullAndCurrentLatLongNotNull) setPage(1)

        const params = new URLSearchParams({page, size, region});
        if (lat != null) params.append('lat', lat.toString());
        if (long != null) params.append('long', long.toString());
        let url = `/v1/library?${params}`;

        BooksitoutServer.get(url)
            .then(res => {
                if (isRegionDifferentFromPrevious || isPreviousLatLongNullAndCurrentLatLongNotNull) {
                    setLibraries(res.data.contents ?? [])
                } else {
                    setLibraries(prev => [...prev, ...(res.data.contents ?? [])])
                }

                setIsLast(res.data.isLast)
                setTotalPages(res.data.totalPages)
                setPreviousRegion(region)
                setIsPreviousLatLongNotNull(isCurrentLatLongNotNull)
            })
            .catch(() => setIsError(true))
            .finally(() => setIsLoading(false))
    }, [page, region, lat, long])

    const paging: Paging = {
        hasMore: !isLast && !isError,
        totalPages: totalPages,
        fetchNext: () => setPage(p => p + 1),
    }

    return [libraries, isLoading, isError, paging] as const
}

export default useLibraryByBookCount
